// converts an array of cloudinary images to one image per device (desktop/tablet/mobile)
const cloudinaryImagePerDevice = (images) => ({
  desktop: images[0]?.secure_url,
  tablet: images?.length > 2 ? images[1]?.secure_url : images[0]?.secure_url,
  mobile:
    images?.length > 2
      ? images[2]?.secure_url
      : images?.length > 1
      ? images[1]?.secure_url
      : images[0]?.secure_url,
})

export default cloudinaryImagePerDevice
